import type { UserRole } from "@/api/enums";
import type { Endpoint } from "./types";

// ── Types ──────────────────────────────────────────────────────────

export interface PasswordlessRequestDto {
  email: string;
}

export interface SignupRequestDto {
  email: string;
  firstName: string;
  lastName: string;
  /** Must be `true` — the API rejects a signup that does not accept the terms. */
  acceptedTerms: boolean;
  emailMarketingConsent: boolean;
}

export interface SignupResponse {
  ok: boolean;
}

export interface PasswordlessVerifyDto {
  email: string;
  code: string;
}

export interface PasswordlessVerifyResponse {
  accessToken: string;
}

export interface DecodedJwt {
  sub: string;
  email?: string;
  roles: UserRole[];
  iat: number;
  exp?: number;
}

export type LogoutResponse = void;

// ── Endpoints ──────────────────────────────────────────────────────

export const authEndpoints = {
  // The only route with request validation switched on, so unknown properties
  // are stripped: send exactly the fields of `SignupRequestDto`.
  signup: {
    method: "POST",
    path: "/auth/signup",
  } as Endpoint,

  requestPasswordless: {
    method: "POST",
    path: "/auth/passwordless/request",
  } as Endpoint,

  verifyPasswordless: {
    method: "POST",
    path: "/auth/passwordless/verify",
  } as Endpoint,

  logout: {
    method: "POST",
    path: "/auth/logout",
    auth: true,
  } as Endpoint,
} as const;
